import { render, staticRenderFns } from "./HighchartsCallHistogram.vue?vue&type=template&id=31b61aa0&scoped=true"
import script from "./HighchartsCallHistogram.vue?vue&type=script&lang=js"
export * from "./HighchartsCallHistogram.vue?vue&type=script&lang=js"
import style0 from "./HighchartsCallHistogram.vue?vue&type=style&index=0&id=31b61aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b61aa0",
  null
  
)

export default component.exports